import { useState } from "react";

export const useHoneypot = () => {
  const [honeypotValue, setHoneypotValue] = useState("");

  const isBot = honeypotValue !== "";

  const honeypotProps = {
    value: honeypotValue,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => setHoneypotValue(e.target.value),
    style: {
      position: "absolute" as const,
      left: "-9999px",
      width: "1px",
      height: "1px",
      opacity: 0,
      pointerEvents: "none" as const,
    },
    tabIndex: -1,
    autoComplete: "off" as const,
    "aria-hidden": true,
  };

  return {
    isBot,
    honeypotProps,
    honeypotValue,
  };
};
